// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1239":"ff2563ed","5211":"ff2563ed","7942":"030d9e96"}[chunkId] + ".chunk.css";
};